export default {
    title: 'Change password',
    old: {
        label: 'Password (old)',
        error: 'Please enter your old password'
    },
    new1: {
        label: 'Password (new)',
        required: 'Please enter your new password',
        max: 'Maximal length is 255 chars',
        complex: 'Unfortunately, the password does not meet the criterias (please see below)'
    },
    guidelines: {
        intro: 'Please note that your password must meet the following criteria:',
        top1: 'Your password must contain at least 8 characters.',
        top2: 'Use at least one uppercase and one lowercase letter.',
        top3: 'Use at least one number and one special character.'
    },
    new2: {
        label: 'Password (repeat)',
        error: 'Both passwords must be identical'
    },
    success: 'Your password was successfully changed.',
    action: 'Submit'
}
